import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import renderHTML from "react-render-html";
import { getPage } from "../../store/actions/pages_action";
import Spinner from "../../components/layout/Spinner";
import SingleItem from "../../components/template/SingleItem";
import { Link } from "react-router-dom";
const ViewPage = ({ getPage, match, page: { loading, page } }) => {
  useEffect(() => {
    getPage(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Pages"
          mainLinkTitle="Pages"
          mainLinkUrl="/pages"
          activeLink="View"
        />
        {!loading ? (
          page && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <div>
                        <h4 className="card-title">
                          {page.name} <span>View</span>
                        </h4>
                        <p className="card-title-desc">
                          <Link to="/pages" className="btn btn-soft-light">
                            <i className="fa fa-angle-left"></i> Pages
                          </Link>
                          <Link
                            to={`/pages/${page.id}/edit`}
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </p>
                      </div>
                    </div>
                    <div className="card-body">
                      <SingleItem title="title" value={page.title} />

                      {page.featured_image && (
                        <SingleItem title="Featured Image">
                          <img
                            src={`${page.featured_image}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                            }}
                          />
                        </SingleItem>
                      )}
                      {page.gallery && (
                        <SingleItem title="Gallery">
                          {page.gallery.map((pic) => {
                            return (
                              <img
                                src={pic}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            );
                          })}
                        </SingleItem>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card">
                    <div className="card-header"> Content </div>
                    <div className="card-body">
                      <div className="card-content">
                        {page.content && renderHTML(page.content)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ page: state.page });

const mapDispatchToProps = { getPage };

export default connect(mapStateToProps, mapDispatchToProps)(ViewPage);
